export enum TolkPackageEnum {
    TenMinutes = 10,
    FifteenMinutes = 15,
    TwentfiveMinutes = 25,
    ThirtyMinutes = 30,
    FortyMinutes = 40,
    SixtyMinutes = 60
}